// get value from object for case insensitive field

function getCaseInSensitiveFieldValueFromObject(field, obj) {

    if (typeof obj !== 'object') return undefined;


    try {
        let fieldStr = String(field);
        fieldStr = fieldStr.toLowerCase();

        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {

                if (fieldStr == key.toLocaleLowerCase()) {

                    return obj[key];
                }
            }
        }

    } catch (error) {

        console.log("Error in GetCaseInsensitiveFieldFromObject.js", error);
        return undefined;
    }


    return undefined;
} 

export default getCaseInSensitiveFieldValueFromObject;